import { notifications } from "@mantine/notifications";
import { methodType } from "src/types/Method.type";
import { NotificationType } from "src/types/Notification.type";
import { translate as t } from "./initLanguage";
import Application from "../classes/Application";
import Config from "../classes/application/Config";

export function notifyError(
  err: string,
  status: number,
  type?: NotificationType
) {
  console.error({ err });

   const cfg = Config.getInstance();

  if(cfg.hasProgressiveRegister()) {
    if(err=="no company id") {
      return;
    }
    if(err=="[object Response]") {
      return;
    }
    /**@todo to be changed
     * hiding all erros
     */
    return ;
  }
  return notifications.show({
    title: t(err),
    message: `status code: ${status}`,
    variant: type ?? NotificationType.danger,
    withCloseButton: false,
  });
}

export function notifySuccess(method: methodType) {
  switch (method) {
    case "POST": {
      return notifications.show({
        title: t("create_success"),
        message: "",
        withCloseButton: false,
      });
    }
    case "PATCH":
    case "PUT": {
      return notifications.show({
        title: t("update_success"),
        message: "",
        withCloseButton: false,
      });
    }
    case "DELETE": {
      return notifications.show({
        title: t("remove_success"),
        message: "",
        withCloseButton: false,
      });
    }
    case "GET":
    case "UPLOAD":
    default: {
      return;
    }
  }
}
